import React from 'react';
import { useTheme } from '../context/ThemeContext';

const FileItem = ({ name, isSelected, onClick }) => {
  const { colors } = useTheme();
  return (
    <div
      className={`flex items-start gap-2 cursor-pointer px-2 py-1 rounded transition-colors w-full ${isSelected ? '' : 'hover:opacity-80'
        }`}
      style={{ backgroundColor: isSelected ? colors.surface : 'transparent' }}
      onClick={onClick}
    >
      <div
        className="mt-1 flex-shrink-0"
        style={{
          width: '19px',
          height: '16px',
          backgroundColor: colors.textPrimary,
          maskImage: 'url(/folders/document-icon.svg)',
          WebkitMaskImage: 'url(/folders/document-icon.svg)',
          maskSize: 'contain',
          WebkitMaskSize: 'contain',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat'
        }}
      />
      <span
        className={`text-[20px] leading-snug truncate max-w-full ${isSelected ? 'font-medium' : ''
          }`}
        style={{ color: isSelected ? colors.textPrimary : colors.textSecondary }}
        title={name} // Show full name on hover
      >
        {name}
      </span>
    </div>
  );
};

export default FileItem;
